import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export const fetchLeaveEntryApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.LeaveEntry.leave_list}`,
        {
            params: payload,
        }
    );
    // return response.data;

}
export const createLeaveEntryApi = async (payload) => {
    const response =  await api.post(
        `${apiPath.API_URL}${apiPath.LeaveEntry.create_leave}`,
        payload
    );
    return response.data
}

export const getLeaveEntryByIdApi = async (id) => {
    const response = await api.get(
        `${apiPath.API_URL}${apiPath.LeaveEntry.get_by_id}/${id}`,
    );
    return response.data;
}

export const updateLeaveEntryApi = async (id, payload) => {
    const response = await api.put(
        `${apiPath.API_URL}${apiPath.LeaveEntry.update_leave}/${id}`,
        payload
    );
    return response.data;
}

export const checkDeleteLeaveEntryApi = async (id) => {
  const response = await api.get(
    `${apiPath.API_URL}${apiPath.LeaveEntry.delete_message}/${id}`
  );
  return response.data;
};


export const deleteLeaveEntryApi = async (id) => {
  const response = await api.delete(
    `${apiPath.API_URL}${apiPath.LeaveEntry.delete_leave}/${id}`
  );
  return response.data;
};